import type { MisconceptionDefinition } from '../types';
export const waterEilandenGrensMisconceptions: MisconceptionDefinition[] = [
// ───────────────────────────────────────────────────────────
// Wateren / rivieren / zeeën
// ───────────────────────────────────────────────────────────
{
  id: 'topo.rivier-verkeerde-richting',
  label: 'Rivier in verkeerde richting',
  module: 'Topo',
  description: 'Leerling kiest een rivier die door het verkeerde land of de verkeerde regio stroomt.',
  typicalFamilies: ['TOPO-NL-WATER', 'TOPO-EU-RIVIEREN', 'TOPO-WERELD-RIVIER']
}, {
  id: 'topo.zee-vs-meer-verward',
  label: 'Zee vs. binnenwater verward',
  module: 'Topo',
  description: 'Leerling verwart een zee met een binnenwater (bijv. IJsselmeer als zee), of andersom.',
  typicalFamilies: ['TOPO-NL-WATER', 'TOPO-EU-ZEEEN']
},
// ───────────────────────────────────────────────────────────
// Eilanden / kust
// ───────────────────────────────────────────────────────────
{
  id: 'topo.eiland-verkeerde-keten',
  label: 'Eiland aan verkeerde keten gekoppeld',
  module: 'Topo',
  description: 'Leerling koppelt een Waddeneiland aan een Zeeuws eiland of andersom.',
  typicalFamilies: ['TOPO-NL-EILANDEN']
},
// ───────────────────────────────────────────────────────────
// Buurlanden / EU
// ───────────────────────────────────────────────────────────
{
  id: 'topo.buurland-verkeerde-zijde',
  label: 'Buurland aan verkeerde zijde',
  module: 'Topo',
  description: 'Leerling plaatst een buurland aan de verkeerde kant (oost/west/noord/zuid).',
  typicalFamilies: ['TOPO-NL-BUURLANDEN', 'TOPO-EU-BUURLANDEN']
}, {
  id: 'topo.land-verkeerd-continent',
  label: 'Land op verkeerd continent',
  module: 'Topo',
  description: 'Leerling plaatst een land op het verkeerde continent.',
  typicalFamilies: ['TOPO-WERELD-LANDEN', 'TOPO-WERELD-CONT']
}];